import { render, staticRenderFns } from "./TablePersonalization.vue?vue&type=template&id=63b40b36&"
import script from "./TablePersonalization.vue?vue&type=script&lang=js&"
export * from "./TablePersonalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports